module.exports = __webpack_public_path__ + "images/politie_small199a87f1c8392ed65a34ed4e7a291809.png";